module.exports = __webpack_public_path__ + "img/recharge_go-in.6b732f9a.png";